import React  from "react";

function Banner() {
  return (
    <>
      <div className="banner" id="home">
        <div className="bg-shap">
          <img src="images/banner-pic.png" alt="" className="main" />
          <img src="images/hand-1.png" alt="" className="hand hand-one" />
          <img src="images/hand-2.png" alt="" className="hand hand-two" />
          <img src="images/hand-3.png" alt="" className="hand hand-three" />
          <img src="images/hand-4.png" alt="" className="hand hand-four" />
          <img src="images/love-1.png" alt="" className="love love-one" />
          <img src="images/love-2.png" alt="" className="love love-two" />
          <img src="images/love-3.png" alt="" className="love love-three" />
          <img src="images/love-4.png" alt="" className="love love-four" />
          <img src="images/love-5.png" alt="" className="love love-five" />
          <img src="images/love-6.png" alt="" className="love love-six" />
          <img src="images/love-7.png" alt="" className="love love-saven" />
          <img src="images/love-8.png" alt="" className="love love-eight" />
        </div>
        <div className="hero-area">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-xxl-6 col-xl-8  col-lg-10 text-center">
                <div className="banner-content">
                  <h3
                    className="subtitle wow fadeInDown"
                    data-wow-duration="0.3s"
                    data-wow-delay="0.3s"
                  >
                    Your Small Help make world better
                  </h3>
                  <h1
                    className="head wow fadeInUp"
                    data-wow-duration="0.3s"
                    data-wow-delay="0.3s"
                  >
                    Your Crypto Can Give Hope
                  </h1>
                  <p
                    className="text wow fadeInUp"
                    data-wow-duration="0.3s"
                    data-wow-delay="0.3s"
                  >
                    Find a cause you care for and donate with a click
                  </p>
                  <a
                    href="#donation"
                    className="one button-1 wow fadeInUp"
                    data-wow-duration="0.3s"
                    data-wow-delay="0.3s"
                  >
                    Make Donation{" "}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Banner;
